<template>
    <header class="section-header main-wrap">
        <a :href="$store.state.links.pikabu" class="section-header__link section-header__link--pikabu" target="_blank">
            <img src="./assets/logo.svg" class="section-header__img" alt="pikabu logo">
        </a>
        <a :href="$store.state.links.pik" class="section-header__link section-header__link--pik" target="_blank">
            <img src="./assets/logo-pik2.svg" class="section-header__img" alt="PIK logo">
        </a>
    </header>
</template>

<script>
export default {
}
</script>

<style scoped lang="stylus">
    .section-header {
        display flex
        box-sizing border-box
        align-items center
        justify-content space-between
        margin-top 1.5rem

        +layout-sm-and-up() {
            margin-top 2.3rem
        }

        &__link {
            line-height 0
            text-transform none
            transition-duration 0.3s

            &:hover {
                opacity 0.8
            }

            &:active {
                opacity 0.6
            }

            &--pikabu {
                width 8.1rem

                +layout-md-and-up() {
                    width 11.6rem
                }
            }

            &--pik {
                width 5rem

                +layout-md-and-up() {
                    width 8rem
                    margin-bottom .1rem
                }
            }
        }

        &__img {
            width 100%
            object-fit contain
        }
    }
</style>
